import React, { useState } from "react"
import styles from "./AdFormFirstStep.module.css"
import { ChoicesButton } from "../../../Common/CtaButton/ChoicesButton"
import { AnnotationModal } from "./AnnotationModal"
import { useAbTestGtm } from "../../../../../hooks/useAbTestGtm"

/**
 * 1stステップ。在職/離職を尋ねる質問画面
 *
 * ページ表示時に注釈モーダルを自動で開く。戻るボタンは表示しない。
 * メール/パスワード入力は12ページ目（確認画面の直前）にある。
 */
export const AdFormFirstStep = () => {
    const { dataViewLabel, dataClickLabel } = useAbTestGtm()
    const [isModalOpen, setIsModalOpen] = useState(true)

    return (
        <div className={styles.wrapper}>
            <h1
                className={styles.titleText}
                data-view-label={dataViewLabel("EF_StepForm_現在の状況")}
            >
                現在の状況はいかがですか？
            </h1>
            <div className={styles.selectionWrapper}>
                <ChoicesButton
                    imageSrc="/foodslaboEf/img/step1/people-cook.png"
                    imageAlt="料理人イラスト"
                    text="在職中"
                    formKey="situation"
                    formValue="tenure"
                    displayFormKey="situation"
                    displayFormValue="在職中"
                    dataClickLabel={dataClickLabel(
                        "EF_StepForm_現在の状況-在職中"
                    )}
                />
                <ChoicesButton
                    imageSrc="/foodslaboEf/img/step1/people-normal.png"
                    imageAlt="男性イラスト"
                    text="離職中"
                    formKey="situation"
                    formValue="resignation"
                    displayFormKey="situation"
                    displayFormValue="離職中"
                    dataClickLabel={dataClickLabel(
                        "EF_StepForm_現在の状況-離職中"
                    )}
                />
            </div>
            <a
                href="/login"
                className={styles.loginLink}
                data-click-label={dataClickLabel(
                    "EF_StepForm_現在の状況-会員登録済み"
                )}
            >
                会員登録済みの方はこちら
            </a>
            <AnnotationModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
            />
        </div>
    )
}
